import React, { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export const FeedbackMenu = lazy(() => import("@kaltura/mediaspace-features-feedback/feedback-menu/FeedbackMenu"));
export const FeedbackDrawer = React.lazy(
    () => import("@kaltura/mediaspace-features-feedback/feedback-drawer/FeedbackDrawer")
);

const MyFeedback = lazy(() => import("@kaltura/mediaspace-features-feedback/my-feedback/MyFeedback"));
const ManageFeedback = lazy(() => import("@kaltura/mediaspace-features-feedback/manage-feedback/ManageFeedback"));

export const renderMyFeedback = getDsLayoutComponentRenderer(MyFeedback);
export const renderManageFeedback = getDsLayoutComponentRenderer(ManageFeedback);
